import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { PrimaryButton } from 'components/buttons/primary-button';
import ModalLayout from 'components/modals/baseModal/base';

import { toggleModal } from 'data/actions/modals';

import cover from './assets/cover.png';

export const CancelCouponSuccessModalABCFc2y1 = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <ModalLayout>
      <div className='flex flex-col items-center justify-center p-2'>
        <img
          src={cover}
          alt='image_cancel'
          className='w-[585px] h-[290px]'
        />
        <h1 className='text-[30px] font-bold pt-10 mx-5'>{t('popups.cancel_flow_ab_update_success.title')}</h1>
        <p className='text-[20px] text-[##1D1D1D] mx-5'>{t('popups.cancel_flow_ab_update_success.subtitle')}</p>
        <PrimaryButton
          className='px-20 py-4 mt-8 font-bold mb-10 mx-5'
          onClick={() => {
            dispatch(toggleModal({ visible: false }));
          }}
        >
          {t('popups.cancel_flow_ab_update_success.button')}
        </PrimaryButton>
      </div>
    </ModalLayout>
  );
};
